import { render, staticRenderFns } from "./PalletReceiptsLogItem.vue?vue&type=template&id=c2f1af5a"
import script from "./PalletReceiptsLogItem.vue?vue&type=script&lang=js"
export * from "./PalletReceiptsLogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports